<template>
  <w-icon-wrapper icon-name='work-arrow-down-icon'>
    <g
      id='_68_Arrow_Down_Icon'
      data-name='68 Arrow Down_Icon'
      transform='translate(0 -0.104)'
    >
      <path
        id='Pfad_55773'
        d='M12,.1a12,12,0,1,0,12,12A12,12,0,0,0,12,.1Zm0,22a10,10,0,1,1,10-10A10.011,10.011,0,0,1,12,22.1Z'
        data-name='Pfad 55773'
        fill='currentColor'
      />
      <path
        id='Pfad_55774'
        d='M17.293,8.189,12,13.482,6.707,8.189A1,1,0,0,0,5.293,9.6L12,16.311,18.707,9.6a1,1,0,1,0-1.414-1.415Z'
        data-name='Pfad 55774'
        fill='currentColor'
        transform='translate(0 1)'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconArrowDown' };
</script>
